import React from "react";
import { Routes, Route } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import MainLayout from "./components/MainLayout";
import HomePage from "./pages/HomePage";
import ProblemDetailPage from "./pages/ProblemDetailPage";
import GameReadyPage from "./pages/GameReadyPage";
import WaitingRoomPage from "./pages/WaitingRoomPage";
import CreatePage from "./pages/CreatePage";
import CreateDetailPage from "./pages/CreateDetailPage";
import CreateQuizPage from "./pages/CreateQuizPage";
import MySetPage from "./pages/MySetPage";
import HistoryPage from "./pages/HistoryPage";
import HistoryDetailPage from "./pages/HistoryDetailPage";
import LandingPage from "./pages/LandingPage";
import LoginPage from "./pages/LoginPage";
import PhotoGallery from "./pages/PhotoGallery";
import Media from "./pages/Media.js";
import Settings from "./pages/Settings";
import RegisterPage from "./pages/RegisterPage";
import PlayPage from "./pages/PlayPage";
import CommunityPage from "./pages/CommunityPage";
import CommunityDetailPage from "./pages/CommunityDetailPage";
import ARGamePage from "./pages/ARGamePage";
import ARGameSoloPage from "./pages/ARGameSoloPage";
import ARDemoPage from "./pages/ARDemoPage";
import ARLandingPage from "./pages/ARLandingPage";
import ObjectUploadPage from "./pages/ObjectUploadPage";
import CoverImageEditPage from "./pages/CoverImageEditPage";
import LogManagementPage from "./pages/LogManagementPage";
import PricingPage from "./pages/PricingPage";
import PolicyPage from "./pages/PolicyPage";
import NoticePage from "./pages/NoticePage";
import HelpPage from "./pages/HelpPage";
import BugReportPage from "./pages/BugReportPage";
import ProtectedRoute from "./components/ProtectedRoute"
import { LikeProvider } from "./context/LikeContext"

function App() {
  return (
    <LikeProvider>
      <Toaster position="top-right" />
      <Routes>
        {/* 랜딩 페이지와 로그인 페이지는 MainLayout 밖에 위치 */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<LoginPage />} />
        
        {/* MainLayout을 사용하는 라우트들 */}
        <Route element={<MainLayout />}>
          <Route path="/home" element={<HomePage />} />
          <Route path="problem/:id" element={<ProblemDetailPage />} />
          <Route path="game-ready" element={<ProtectedRoute><GameReadyPage /></ProtectedRoute>} />
          <Route path="waiting-room" element={<ProtectedRoute><WaitingRoomPage /></ProtectedRoute>} />
          <Route path="create" element={<ProtectedRoute><CreatePage /></ProtectedRoute>} />
          <Route path="createdetail" element={<ProtectedRoute><CreateDetailPage /></ProtectedRoute>} />
          <Route path="createquiz" element={<ProtectedRoute><CreateQuizPage /></ProtectedRoute>} />
          <Route path="create/edit/:id" element={<ProtectedRoute><CreateQuizPage /></ProtectedRoute>} />
          <Route path="myset" element={<ProtectedRoute><MySetPage /></ProtectedRoute>} />
          <Route path="myset/cover-edit/:id" element={<ProtectedRoute><CoverImageEditPage /></ProtectedRoute>} />
          <Route path="trends" element={<div>Trends Page Coming Soon</div>} />
          <Route path="play" element={<ProtectedRoute><PlayPage /></ProtectedRoute>} />
          <Route path="community" element={<CommunityPage />} />
          <Route path="community/:id" element={<CommunityDetailPage />} />
          <Route path="history" element={<ProtectedRoute><HistoryPage /></ProtectedRoute>} />
          <Route path="history/:gameId" element={<ProtectedRoute><HistoryDetailPage /></ProtectedRoute>} />
          <Route path="data" element={<ProtectedRoute><div>Data Page Coming Soon</div></ProtectedRoute>} />
          <Route path="photos" element={<PhotoGallery />} />
          <Route path="media" element={<Media />} />
          <Route path="settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
          <Route path="objectupload" element={<ProtectedRoute><ObjectUploadPage /></ProtectedRoute>} />
          <Route path="logs" element={<ProtectedRoute><LogManagementPage /></ProtectedRoute>} />
          <Route path="pricing" element={<PricingPage />} />
          <Route path="notice" element={<NoticePage />} />
          <Route path="help" element={<HelpPage />} />
          <Route path="bugreport" element={<BugReportPage />} />
        </Route>
        
        {/* AR 게임 페이지는 MainLayout 밖에 위치 (풀스크린) */}
        <Route path="/ar-game" element={<ARGamePage />} />
        <Route path="/ar-game-solo" element={<ARGameSoloPage />} />
        <Route path="/ar-demo" element={<ARDemoPage />} />
        <Route path="/ar-landing" element={<ARLandingPage />} />

        {/* 개인정보처리방침 */}
        <Route path="/policy" element={<PolicyPage />} />
      </Routes>
    </LikeProvider>
  );
}

export default App;